<template>
  <div>
    <!-- メイン画面 -->
    <div v-if="park" class="content-wrapper">
      <!-- 施設情報表示 -->
      <DBSFacilityCard :park="park" :button-action="goToDetailDbs" />
      <!-- 施設情報表示 -->
    </div>
    <!-- メイン画面 -->

    <!-- isReadyToDrawがtrueになるまで -->
    <FacePhraseForIndexPage
      v-else
      phrase="周辺にご案内できるポートはありません"
    />
  </div>
  <!---全体を囲む--->
</template>

<script>
import nativeHandlerService from "@/services/nativeHandler";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "TemplateDbsIndex",
  setup() {
    const store = useStore();
    const router = useRouter();

    const park = computed(() => store.getters["dbs/park"]);
    const isReadyToDraw = ref(false);

    const goToPlaceDbs = () => {
      nativeHandlerService.ncGotoPlaceDbs(park.value);
    };

    const goToDetailDbs = () => {
      // 未ログイン時は遷移不可
      const isLogin = store.getters["common/isLogin"];
      if (!isLogin) {
        nativeHandlerService.returnNativeAppToAccountPage();
      } else {
        nativeHandlerService.ncSetPlaceInfoDbs(park.value);

        router.push({
          name: "DbsDetail",
          params: {
            park_id: park.value.Station.code.split(".")[1],
          },
        });
      }
    };
    return {
      park,
      goToPlaceDbs,
      goToDetailDbs,
    };
  },
};
</script>
